import NinjaTable from 'components/tables/NinjaTable';
import React from 'react';
import DisconnectButton from 'modules/apps/components/DisconnectButton';

const columns = [
  {
    key: 'id',
    name: 'ID',
    resizable: true,
    frozen: true,
  },
  {
    key: 'name',
    name: 'Name',
    resizable: true,
  },
  {
    key: 'currency',
    name: 'Currency',
    resizable: true,
  },
  {
    key: 'domain',
    name: 'URL',
    resizable: true,
  },
  {
    key: 'disconnect',
    name: 'disconnect',
    width: 130,
    renderCell: ({ row }) => {
      return <DisconnectButton integration={row.type} id={row.id} name={row.name} />;
    },
  },
];

const ConnectedClickFunnels = (props) => {
  return (
    <NinjaTable
      title='Connected stores'
      columns={columns}
      dataProvider='integrationList'
      queryParams={{ integration: 'clickfunnels' }}
      disableFooter
    />
  );
};

export default ConnectedClickFunnels;
